<template>
	<div>
		


		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Mobil - Belakang</h5>
			</template>
			<div class="row mt-3">
				<div class="col-sm-4 col-lg-2 col-12 label-car-type">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
				</div>
			</div>
			

			<div class="row mt-2">
				<div class="col-12 p-10" style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterRearSedan' : carType == 'sedan', 'workOrderOuterRearMinibus' : carType == 'minibus'}" v-if="!exit">
							

							<!-- <div class="workOrderInnerRearSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerRearSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas> -->
						<template v-if="carType == 'sedan'">
							<div class="workOrderInnerRearSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerRearSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas>
						</template>
						<template v-else>
							<div class="workOrderInnerRearMinibus h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerRearMinibus h-100 w-100"  id="canvasMinibus" style="z-index:50;" >
								
							</canvas>
						</template>
							
						
					</div>
					<div v-else>
							<img v-if="imageSrc" :src="env.baseImage + '/' + imageSrc"  class="workOrderParent"/>

							<div v-else class="mt-5 mb-5 text-center">
								<h2>Tidak Melakukan Tanda Terima</h2>
							</div>

					</div>

					<!-- <img v-if="canvasResult" :src="canvasResult" /> -->
					
					
				</div>
				<div class="col-12 row mt-1 mb-5" v-if="!exit">
					<div class="col-12 mb-2 pl-4 mt-2">
						<label>Pilih Kondisi Berikut untuk Menandai Mobil</label>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-green' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2 color-green"></i> Boncel</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-blue' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-circle fa-lg mr-2 color-blue"></i> Baret</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-yellow' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-circle fa-lg mr-2 color-yellow"></i> Penyok</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-red' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-circle fa-lg mr-2 color-red"></i> Pecah</button>
					</div>
					<div class="col-sm-4 col-12 offset-lg-2 col-lg-2 pl-4 text-right mt-2">
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
						
				</div>
					<!-- <div class="workOrderParent" :class="{'workOrderOuterRearSedan' : carType == 'sedan', 'workOrderOuterRearMinibus' : carType == 'minibus'}">
						<div v-if="carType == 'sedan'" class="workOrderInnerRearSedan">
							<div class="carWindowRearSedan" v-on:click="selectPart('rear.carWindowBelakang' , carType)" :class="{'carWindowRearSedanActive' : data.condition.figure.sedan.rear.carWindowBelakang.desc != ''}">
							</div>
							<div class="emblemRearSedan" v-on:click="selectPart('rear.emblem' , carType)" :class="{'emblemRearSedanActive' : data.condition.figure.sedan.rear.emblem.desc != ''}">
							</div>
							<div class="bumperLightKiriSedan" v-on:click="selectPart('rear.bumperLightKiri' , carType)" :class="{'bumperLightKiriSedanActive' : data.condition.figure.sedan.rear.bumperLightKiri.desc != ''}">
							</div>
							<div class="bumperLightKananSedan" v-on:click="selectPart('rear.bumperLightKanan' , carType)" :class="{'bumperLightKananSedanActive' : data.condition.figure.sedan.rear.bumperLightKanan.desc != ''}">
							</div>
							<div class="bumperRearSedan" v-on:click="selectPart('rear.bumperBelakang' , carType)" :class="{'bumperRearSedanActive' : data.condition.figure.sedan.rear.bumperBelakang.desc != ''}">
							</div>
							
							<div class="bagasiSedan" v-on:click="selectPart('rear.bagasi' , carType)" :class="{'bagasiSedanActive' : data.condition.figure.sedan.rear.bagasi.desc != ''}">
							</div>

							
							<div class="backLightKiriSedan" v-on:click="selectPart('rear.backLightKiri' , carType)" :class="{'backLightKiriSedanActive' : data.condition.figure.sedan.rear.backLightKiri.desc != ''}">
							</div>
							<div class="backLightKananSedan" v-on:click="selectPart('rear.backLightKanan' , carType)" :class="{'backLightKananSedanActive' : data.condition.figure.sedan.rear.backLightKanan.desc != ''}">
							</div>

						</div>
						<div v-else class="workOrderInnerRearMinibus">
							

						</div>						
					</div> -->

					
				<div class="col-12">
					<h4 class="text-center">Kondisi {{carTypes.charAt(0).toUpperCase() + carTypes.slice(1)}}</h4>
					<hr>
					<div class="row">
						<div class="col-4" v-for="checklistCar in Object.keys(data.condition.figure[carType].rear)" :key="checklistCar">
							<div class="row mt-2">
								<div class="col-6">
									<p>{{translatePart(checklistCar).split(/(?=[A-Z])/).join(' ')}}</p>
									
								</div>
								<div class="col-6 text-center">
									<input type="checkbox" disabled  v-model="data.condition.figure[carType].rear[checklistCar].desc" >
								</div>
							</div>
							<p v-if="exit && data.condition.figure[carTypes].rear[checklistCar].desc != ''" style="font-weight:bold">Deskripsi Rusak : <br>{{data.condition.figure[carTypes].rear[checklistCar].desc}}</p>
							<template v-else-if="exit">
								<div class="mt-5"></div>
							</template>
							<hr style="margin-top:5px;margin-bottom:5px;">
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="mt-3 row">
				<template v-for="checklist in checklistSettings" >
					<div class="col-6 col-md-2 mt-2 p-3 text-center " :key="checklist.name" v-if="checklist.name.includes('REAR_')" >
						<div 
							class="border border-secondary rounded checklist" 
							:class="{'Selected' : checkSettings[checklist.name]}" 
							
							@click="checked(checklist.name)"
						>
							<h5>{{data.condition.checklist[checklist.name] ? 'Terpilih' : 'Tidak Dipilih'}}</h5>
							<img :src="checklist.img ? checklist.img : '/img/WorkOrder/Logo/' + checklist.name.split('REAR_')[1] + '.png'" class="img-fluid" style="width:100%;height:auto"  alt="Tidak ada Gambar"/>
							<h5>{{checklist.name.split('REAR_')[1]}}</h5>
						</div>
					</div>
				</template>
			</div> -->

			
			
		</panel>

		<div class="row">
			<div class="col-md-6 col-0">
				
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" @click="nextPage" :disabled="apiLoading">Berikutnya</button>
			</div>
		</div>

		

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>

	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import env from '@/env'
	

	export default {
		components: {
			Multiselect,
			modalUploadImage

		},
		data () {
			return {
				env,
				showModal: false,
				part: '',
				partHeader : '',
				carTypes : this.carType,
				showFrontModal: false,
				checkSettings : this.data.condition.checklist,
				curShape : 'Boncel',
				listOfPoints : [],
				gridMap : null,
				gridMapMinibus : null,
				imageSrc : null,
				canvasResult : null
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType', 'title' , 'exit' , 'previousCheckingCondition', 'apiLoading'],
		mounted () {

			if(this.exit)
				this.imageSrc = this.previousCheckingCondition.condition.figureOverall.rear.image.length > 0 
				&& this.previousCheckingCondition.condition.figureOverall.rear.image[0] != 'test image'? 
					this.previousCheckingCondition.condition.figureOverall.rear.image[0]
					: null

			this.loadGridCanvas()
			if(this.exit) {
				let keys = Object.keys(this.data.condition.figure[this.carType].rear)
				console.log(this.previousCheckingCondition.condition.figure.rear);

				for(var i = 0 ; i < keys.length ; i++) {
					let nowCondition = this.data.condition.figure[this.carType].rear[keys[i]]
					let prevCondition = this.previousCheckingCondition.condition.figure.rear[keys[i]]
					if(prevCondition.desc != '') {
						nowCondition.desc = prevCondition.desc
						console.log(nowCondition)
					}
				}
			}
		},
		methods: {
			async loadGridCanvas () {
				let col = [34, 25, 8, 23, 8, 9, 55, 62, 30, 62, 54, 9, 9, 22, 8, 27];
				let row = [20, 67, 10, 13, 5, 19, 7, 23, 21, 29, 14, 51];

				let  obj = [{
					name : 'rear.carWindowBelakang',
					startCol : 5,
					endCol  : 14,
					startRow : 2 , 
					endRow : 3
				}, {
					name : 'rear.emblem',
					startCol : 9,
					endCol  : 10,
					startRow : 6 , 
					endRow : 7
				},{
					name : 'rear.bumperLightKiri',
					startCol : 4,
					endCol  : 7,
					startRow : 11 , 
					endRow : 12
				}, {
					name : 'rear.bumperLightKanan',
					startCol : 12,
					endCol  : 15,
					startRow : 11 , 
					endRow : 12
				}, {
					name : 'rear.bumperBelakang',
					startCol : 2,
					endCol  : 17,
					startRow : 8 , 
					endRow : 13
					
				}, {
					name : 'rear.bagasi',
					startCol : 6,
					endCol  : 13,
					startRow : 4 , 
					endRow : 10
				}, {
					name : 'rear.backLightKiri',
					startCol : 3,
					endCol  : 8,
					startRow : 5 , 
					endRow : 9
				}, {
					name : 'rear.backLightKanan',
					startCol : 11,
					endCol  : 16,
					startRow : 5 , 
					endRow : 9
				}]

				let colMinibus = [6, 11, 10, 18, 3, 24, 66, 67, 38, 67, 66, 22, 4, 20, 8, 11]
				let rowMinibus = [30, 94, 16,  3, 17, 8, 76, 26, 49, 11, 17, 39]

				let objMinibus = [{
					name : 'rear.carWindowBelakang',
					startCol : 5,
					endCol  : 14,
					startRow : 2 , 
					endRow : 5
				},{
					name : 'rear.emblem',
					startCol : 9,
					endCol  : 10,
					startRow : 5 , 
					endRow : 7
				},{
					name : 'rear.bumperLightKiri',
					startCol : 12,
					endCol  : 15,
					startRow : 11 , 
					endRow : 12
					
				},{
					name : 'rear.bumperLightKanan',
					startCol : 4,
					endCol  : 7,
					startRow : 11 , 
					endRow : 12
				},{
					name : 'rear.bumperBelakang',
					startCol : 2,
					endCol  : 17,
					startRow : 9 , 
					endRow : 13
				},{
					name : 'rear.bagasi',
					startCol : 6,
					endCol  : 14,
					startRow : 3 , 
					endRow : 10
				},{
					name : 'rear.backLightKiri',
					startCol : 11,
					endCol  : 16,
					startRow : 6 , 
					endRow : 8
				},{
					name : 'rear.backLightKanan',
					startCol : 3,
					endCol  : 8,
					startRow : 6 , 
					endRow : 8
				}]

				this.gridMap = await this.mapGridCanvas(col , row , obj)
				this.gripMapMinibus = await this.mapGridCanvas(colMinibus , rowMinibus , objMinibus)
			},
			async mapGridCanvas(col , row , obj) {
			
				for(var i = 0 ; i < obj.length ; i++) {
					let curObj = obj[i]
					curObj.startColLength= col.slice(0 , curObj.startCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endColLength = col.slice(0, curObj.endCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.startRowLength= row.slice(0 , curObj.startRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endRowLength = row.slice(0, curObj.endRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
				}

				

				return obj
			},
			addShape(e = null ,click) {
				if(!e) {
					this.listOfPoints.length = 0
					// this.selected.length = 0
				}
				else {
					let x = 0
					let y = 0

					x = e.offsetX
					y = e.offsetY
					// console.log(x, y)
					

					let selectedGrid = this.carTypes == 'sedan' ? this.gridMap : this.gripMapMinibus

					let area = selectedGrid.filter(z => 
						z.startColLength <=  x &&
						z.endColLength >= x &&
						z.startRowLength <= y &&
						z.endRowLength >= y
					)

					if(area.length > 0) {
						// this.selected.push(area.name)
						
						if(area.length == 1)
							this.data.condition.figure[this.carTypes].rear[area[0].name.split('.')[1]] = {
								desc : this.curShape
							}
						else {
							let res = []

							for(var i = 0 ; i < area.length ; i++) {
								let z = area[i]
								res[i] = (z.endColLength - x) + (z.endRowLength - y)
								// console.log(z.name , res[i])
							}

							var max = Math.min(...res)
							let index = res.indexOf(max)
							// console.log(area[index] , max)

							

							// this.selectPart(area[index].name , this.carTypes)
							this.data.condition.figure[this.carTypes].rear[area[index].name.split('.')[1]] = {
								desc : this.curShape
							}
						}
					}
					this.listOfPoints.push({x , y , shape : this.curShape})
				}
				// console.log(click)
				// const canvas = document.getElementById('canvasSedan');
				// const context = canvas.getContext('2d');
				// context.font='14px Font Awesome 5 Free';
				// canvas.width = 476.7
				// canvas.height = 342.03
				let canvas = null
				let context = null

				if(this.carTypes == 'sedan') {
					canvas = document.getElementById('canvasSedan');
					context = canvas.getContext('2d');
					canvas.width = 476.7
					canvas.height = 342.03
				}
				else {
					canvas = document.getElementById('canvasMinibus');
					context = canvas.getContext('2d');
					canvas.width = 450
					canvas.height = 450	
				}

				
			
				
				for(var i = 0 ; i < this.listOfPoints.length ; i++) {
					context.beginPath();
					
					let x = this.listOfPoints[i].x
					let y = this.listOfPoints[i].y

					let fillStyle = '';

					if(this.listOfPoints[i].shape == 'Boncel')
						fillStyle = '#29BC53'
					else if(this.listOfPoints[i].shape == 'Penyok')
						fillStyle = '#FFDD05'
					else if(this.listOfPoints[i].shape == 'Baret')
						fillStyle = '#007ED9'
					else if(this.listOfPoints[i].shape == 'Pecah')
						fillStyle = '#FF0000'

					// console

					context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );
					context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					context.fillStyle = fillStyle;
					context.fill();
					context.stroke();
				}
				// var dataURL = canvas.toDataURL();
				// console.log(dataURL)
				
				
			},
			reset() {
				this.addShape(null)

				this.data.condition.figureOverall[this.carTypes].rear = { image : [] }

				let keys = Object.keys(this.data.condition.figure[this.carTypes].rear)
				// console.log(keys)

				for(var i = 0 ; i < keys.length ; i++) {
					this.data.condition.figure[this.carTypes].rear[keys[i]] = { desc : '' }
				}
			},

			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'
					else if (strSplit[i] == 'car')
						strSplit[i] = 'mobil'
					else if (strSplit[i] == 'window')
						strSplit[i] = 'kaca'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carTypes].front[part] = url
				else 
					this.data.condition[partHeader][this.carTypes][part] = url
				// alert("Unggah Gambar Berhasil!")

				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.$emit('nextPage')
			},
			nextPage () {

				if(this.data.condition.figureOverall[this.carTypes].rear.image.length > 1) {
					this.$emit('nextPage')
				}
				if(this.exit) {
					this.showModal = true;
					this.part = 'rear'
					this.partHeader = 'figureOverall'
					return
				}
				var destinationCanvas = document.createElement("CANVAS");
				var destCtx = destinationCanvas.getContext('2d');

				var background = new Image();
				let canvasId = this.carTypes == 'sedan' ? 'canvasSedan' : 'canvasMinibus'
				let param = {}

				if(this.carTypes == 'sedan') {
					destinationCanvas.width = 476.7
					destinationCanvas.height = 342.03
					
					background.src = "/img/WorkOrder/Sedan/CAMRY BACK.svg";
					param.width = 650
					param.height = 350
					param.offsetX = -87.5
					param.offsetY = 0
					param.canvasX = 0
					param.canvasY = 0
				}
				else {
					destinationCanvas.width = 530
					destinationCanvas.height = 520
					
					background.src = "/img/WorkOrder/Minibus/ALPHARD BACK.svg";
					param.width = 520
					param.height = 450
					param.offsetX = 20
					param.offsetY = 40
					param.canvasX = 55
					param.canvasY = 40
				}

				let vm = this
				background.onload = async function(){
					destCtx.drawImage(background, param.offsetX , param.offsetY , param.width , param.height );   
					const canvas = document.getElementById(canvasId);
				

					destCtx.drawImage(canvas, param.canvasX, param.canvasY);

					let modifiedFile = vm.dataURLtoFile(destinationCanvas.toDataURL() , 'image.jpg')
					// console.log(destinationCanvas.toDataURL())
					// vm.canvasResult = destinationCanvas.toDataURL()
					
					let formData = new FormData()

					formData.append('work_order' , modifiedFile)
					
					
					try {
						let url = env.urlStart + "/api/v1/workorder/image"
						let response = await vm.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
						let data = response.data.data
						
						vm.data.condition.figureOverall[vm.carTypes].rear = {
							image : [data.filename]
						}
						vm.$emit('nextPage')
					}   catch (err) {
						vm.$store.dispatch('triggerAlert' , [false , ['Something Went Wrong. Please Try Again Later.' , err]])
						console.log(err)
					}       
				}
			}
		}
	}
</script>

<style scoped>
	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		display: flex;
		align-items: center;
		letter-spacing: 0.015em;
		font-size: 14px;
	}
</style>
